<template>
  <div class="section">
    <form class="box" @submit.prevent="submitData()">
      <h2 class="title is-2">Register Connections Ministry</h2>
      Dear JPCC Partners,<br>
      <br>
      Connections Ministry ingin mengajak Anda untuk bergabung sebagai ONE STOP SERVICE dan jembatan untuk menghubungkan gereja dengan kebutuhan jemaat secara langsung di setiap hari Minggu. Anda dapat melayani sebagai berikut:<br>
      <br>
      FLOOR AREA<br>
      * Menyambut dan melayani new people atau new visitor yang pertama kali datang ke JPCC.<br>
      * Melayani jemaat yang lahir baru.<br>
      * Melayani jemaat yang ingin tertanam dan bertumbuh di JPCC dalam DATE.<br>
      * Melayani jemaat yang mencari atau menemukan barang-barang yang hilang selama di gereja JPCC.<br>
      <br>
      FRONT DESK<br>
      * Melayani registrasi setiap event yang ada di JPCC.<br>
      * Melayani jemaat yang akan memberikan persembahan maupun perpuluhan.<br>
      <br>
      Persyaratannya Connections Ministry:<br>
      * Tertanam dalam DATE dan Sudah mengikuti Minimal COB atau Plant.<br>
      * Memiliki kemampuan untuk berkomunikasi dengan new people, new visitor maupun seluruh jemaat (people oriented person) (khusus Flior Area).<br>
      * Memiliki strength utk mengerjakan hal-hal yg berhubungan dengan finance dan administrasi serta memiliki tingkat ketelitian yang tinggi (Khusus Front Desk).<br>
      * Bersedia melayani 2 minggu sekali di The Kasablanka, Upperoom, atau Sutera Hall.<br>
      <br>
      Untuk seleksi dan wawancara akan dihubungi setelah pendaftaran dilakukan via F2F atau Zoom.<br>
      <br>
      Batch 2 : 30-31 Maret 2020 (Khusus Sutera Hall)<br>
      Batch 3 : 14-28 Juni 2020<br>
      Batch 4 : 09-23 Aug 2020<br>
      Batch 5 : 01-15 Nov 2020<br>
      <br>
      Untuk informasi lebih lanjut silakan hubungi:<br>
      Ahui: <a href="tel:+628161652766">0816-1652-766</a><br>
      Siska: <a href="tel:+6281932407318">0819-3240-7318</a><br>
      Anne: <a href="tel:+6281281713061">0812-8171-3061</a><br>
      Email: <a href="mailto:connections.jpcc@gmail.com">connections.jpcc@gmail.com</a><br>
      <br>
      Ayo, bergabung bersama kami!<br>
      <br>
      Blessings, <br>
      Connections Ministry<br><br>
      <h4 class="title is-4">Silahkan isi data diri anda pada form di bawah ini</h4>
      <div class="field">
        <div class="control">
          <label class="label">Nama lengkap sesuai KTP *</label>
          <input type="text" :class="{'input': true, 'is-danger': errors.has('name')}" v-model="name" placeholder="Nama lengkap sesuai KTP *" required>
          <span class="help is-danger" v-show="errors.has('name')" v-text="errors.first('name')"></span>
        </div>
      </div>
      <div class="field">
        <div class="control">
          <label class="label">Tanggal Lahir Anda *</label>
          <input type="date" :class="{'input': true, 'is-danger': errors.has('birthday')}" v-model="birthday" placeholder="Tanggal Lahir Anda *" required>
          <span class="help is-danger" v-show="errors.has('birthday')" v-text="errors.first('birthday')"></span>
        </div>
      </div>
      <div class="field">
        <div class="control">
          <label class="label">Jenis Kelamin Anda? *</label>
          <label class="radio" v-for="(gender_row, index) in gender_list" :key="index">
            <input type="radio" v-model="gender" :value="gender_row.id" required> {{gender_row.title}}
          </label>
          <span class="help is-danger" v-show="errors.has('gender')" v-text="errors.first('gender')"></span>
        </div>
      </div>
      <div class="field">
        <div class="control">
          <label class="label">Nomor Handphone Anda *</label>
          <the-mask :class="{'input': true, 'is-danger': errors.has('phone')}" v-model="phone" placeholder="Nomor Handphone Anda *" mask="(###) ### ### ### ### ###"></the-mask>
          <span class="help is-danger" v-show="errors.has('phone')" v-text="errors.first('phone')"></span>
        </div>
      </div>
      <div class="field">
        <div class="control">
          <label class="label">Email Anda? *</label>
          <input type="email" :class="{'input': true, 'is-danger': errors.has('email')}" v-model="email" placeholder="Email Anda? *" required>
          <span class="help is-danger" v-show="errors.has('email')" v-text="errors.first('email')"></span>
        </div>
      </div>
      <div class="field">
        <div class="control">
          <label class="label">Pekerjaan Anda saat ini? *</label>
          <span>Contoh : Marketing Manager</span>
          <input type="text" :class="{'input': true, 'is-danger': errors.has('job')}" v-model="job" placeholder="Pekerjaan Anda saat ini? *" required>
          <span class="help is-danger" v-show="errors.has('job')" v-text="errors.first('job')"></span>
        </div>
      </div>
      <div class="field">
        <div class="control">
          <label class="label">Nama DATE Anda? *</label>
          <input type="text" :class="{'input': true, 'is-danger': errors.has('date_group')}" v-model="date_group" placeholder="Nama DATE Anda? *" required>
          <span class="help is-danger" v-show="errors.has('date_group')" v-text="errors.first('date_group')"></span>
        </div>
      </div>
      <div class="field">
        <div class="control">
          <label class="label">Sudah Berapa Lama Anda Tergabung dalam DATE? *</label>
          <input type="text" :class="{'input': true, 'is-danger': errors.has('date_group_since')}" v-model="date_group_since" placeholder="Sudah Berapa Lama Anda Tergabung dalam DATE? *" required>
          <span class="help is-danger" v-show="errors.has('date_group_since')" v-text="errors.first('date_group_since')"></span>
        </div>
      </div>
      <div class="field">
        <div class="control">
          <label class="label">Nama DATE LEADER Anda *</label>
          <input type="text" :class="{'input': true, 'is-danger': errors.has('date_group_leader_name')}" v-model="date_group_leader_name" placeholder="Nama DATE LEADER Anda *" required>
          <span class="help is-danger" v-show="errors.has('date_group_leader_name')" v-text="errors.first('date_group_leader_name')"></span>
        </div>
      </div>
      <div class="field">
        <div class="control">
          <label class="label">Nomor Handphone DATE LEADER Anda *</label>
          <the-mask :class="{'input': true, 'is-danger': errors.has('date_group_leader_phone')}" v-model="date_group_leader_phone" placeholder="Nomor Handphone DATE LEADER Anda *" mask="(###) ### ### ### ### ###"></the-mask>
          <span class="help is-danger" v-show="errors.has('date_group_leader_phone')" v-text="errors.first('date_group_leader_phone')"></span>
        </div>
      </div>
      <div class="field">
        <div class="control">
          <label class="label">Ibadah rutin anda? *</label>
          <div class="select">
            <select v-model="routine_service" required>
              <option v-for="(service_row, index) in service_list" :value="service_row.id" :key="index" v-text="service_row.title"></option>
            </select>
          </div>
          <span class="help is-danger" v-show="errors.has('routine_service')" v-text="errors.first('routine_service')"></span>
        </div>
      </div>
      <!-- <div class="field" v-show="false">
        <div class="control">
          <label class="label">Apakah Anda Sudah Pernah Mengikuti Kelas Vision Partner (VP) / Partners Day : *</label>
          <label class="radio" v-for="(choices_row, index) in choices_list" :key="index">
            <input type="radio" v-model="partners_day" :value="choices_row.id" required> {{choices_row.title}}
          </label>
          <span class="help is-danger" v-show="errors.has('partners_day')" v-text="errors.first('partners_day')"></span>
        </div>
      </div>
      <div class="field" v-show="false">
        <div class="control">
          <label class="label">Kapan Anda Mengikuti Vision Partner (VP) / Partners Day? *</label>
          <span>Isi dalam bentuk Bulan dan Tahun</span>
          <input type="text" :class="{'input': true, 'is-danger': errors.has('partners_day_join')}" v-model="partners_day_join" placeholder="Kapan Anda Mengikuti Vision Partner / Partners Day? *" required>
          <span class="help is-danger" v-show="errors.has('partners_day_join')" v-text="errors.first('partners_day_join')"></span>
        </div>
      </div> -->
      <div class="field">
        <div class="control">
          <label class="label">Apakah Anda Sudah Pernah Mengikuti Kelas PLANT? *</label>
          <label class="radio" v-for="(choices_row, index) in choices_list" :key="index">
            <input type="radio" v-model="cob" :value="choices_row.id" @click="checkClasses()" required> {{choices_row.title}}
          </label>
          <span class="help is-danger" v-show="errors.has('cob')" v-text="errors.first('cob')"></span>
        </div>
      </div>
      <div class="field">
        <div class="control">
          <label class="label">Kapan Anda Mengikuti Kelas PLANT? *</label>
          <span>Isi dalam bentuk Bulan dan Tahun</span>
          <input type="text" :class="{'input': true, 'is-danger': errors.has('cob_join')}" v-model="cob_join" placeholder="Kapan Anda Mengikuti PLANT? *" required>
          <span class="help is-danger" v-show="errors.has('cob_join')" v-text="errors.first('cob_join')"></span>
        </div>
      </div>
      <div class="field" v-show="cob === 2">
        <div class="control">
          <label class="label">Apakah Anda Sudah Pernah Mengikuti Kelas SERVE? *</label>
          <label class="radio" v-for="(choices_row, index) in choices_list" :key="index">
            <input type="radio" v-model="col" :value="choices_row.id" @click="checkClasses()"> {{choices_row.title}}
          </label>
          <span class="help is-danger" v-show="errors.has('col')" v-text="errors.first('col')"></span>
        </div>
      </div>
      <div class="field" v-show="cob === 2">
        <div class="control">
          <label class="label">Kapan Anda Mengikuti Kelas SERVE? *</label>
          <span>Isi dalam bentuk Bulan dan Tahun</span>
          <input type="text" :class="{'input': true, 'is-danger': errors.has('col_join')}" v-model="col_join" placeholder="Kapan Anda Mengikuti SERVE? *">
          <span class="help is-danger" v-show="errors.has('col_join')" v-text="errors.first('col_join')"></span>
        </div>
      </div>
      <div class="field" v-show="cob !== 2">
        <div class="control">
          <span class="help is-danger">
            Anda tidak memenuhi persyaratan
          </span>
        </div>
      </div>
      <div class="field" v-if="cob === 2">
        <div class="control">
          <label class="label">Divisi *</label>
          <div class="select" required>
            <select v-model="division">
              <option value="">Select Division</option>
              <option v-for="(division_row, index) in division_list" :value="division_row.id" :key="index" v-text="division_row.title"></option>
            </select>
          </div>
          <span class="help is-danger" v-show="errors.has('division')" v-text="errors.first('division')"></span>
        </div>
      </div>
      <div class="field" v-else>
        <div class="control">
          <label class="label">Divisi *</label>
          <div class="select" required>
            <select v-model="division">
              <option value="">Select Division</option>
            </select>
          </div>
          <span class="help is-danger" v-show="errors.has('division')" v-text="errors.first('division')"></span>
        </div>
      </div>
      <div class="field">
        <div class="control">
          <label class="label">Mengapa Anda Ingin melayani di Connections Ministry? *</label>
          <textarea rows="5" :class="{'textarea': true, 'is-danger': errors.has('why_join')}" v-model="why_join" placeholder="Mengapa Anda Ingin melayani di Connections Ministry? *" required></textarea>
          <span class="help is-danger" v-show="errors.has('why_join')" v-text="errors.first('why_join')"></span>
        </div>
      </div>
      <div class="field">
        <div class="control">
          <label class="label">Apakah Anda Bersedia untuk Melayani baik Kota Kasablanka, Upperroom maupun Alam Sutera? *</label>
          <label class="radio" v-for="(ready_row, index) in ready_list" :key="index">
            <input type="radio" v-model="ready" :value="ready_row.id" required> {{ready_row.title}}
          </label>
          <span class="help is-danger" v-show="errors.has('ready')" v-text="errors.first('ready')"></span>
        </div>
      </div>
      <div class="field">
        <div class="control">
          <label class="label">Tuliskan 5 hal yang menggambarkan diri anda atau karakter pribadi anda<br>(Bukan Hal-Hal yang umum)</label>
          <p>Contoh Hal hal yang umum:</p>
          <p>Saya adalah anak kedua dari 5 bersaudara.<br>Saya adalah seorang karyawan bank.<br>Saya adalah anak yang lahir di Jakarta.<br>Dan sebagainya</p>
          <textarea rows="5" :class="{'textarea': true, 'is-danger': errors.has('self_image')}" v-model="self_image" placeholder="Tuliskan 10 hal yang menggambarkan diri anda atau karakter pribadi anda"></textarea>
          <span class="help is-danger" v-show="errors.has('self_image')" v-text="errors.first('self_image')"></span>
        </div>
      </div>
      <div class="field is-grouped">
        <div class="control">
          <button type="submit" class="button is-link">Submit</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {TheMask} from 'vue-the-mask'

export default {
  data () {
    return {
      name: '',
      birthday: '',
      gender_list: [],
      gender: '',
      phone: '',
      email: '',
      job: '',
      date_group: '',
      date_group_since: '',
      date_group_leader_name: '',
      date_group_leader_phone: '',
      service_list: [],
      routine_service: '',
      choices_list: [],
      partners_day: 0,
      partners_day_join: '',
      cob: 0,
      cob_join: '',
      col: 0,
      col_join: '',
      division_list: [],
      division: '',
      division_message_error: '',
      why_join: '',
      ready_list: [],
      ready: 1,
      self_image: '',
      memberType: ''
    }
  },
  components: {
    TheMask
  },
  created () {
    this.memberType = this.$route.params.memberType
    this.division_list = [
      {
        id: 'fa',
        title: 'Floor Area Umum'
      },
      {
        id: 'fa_ng',
        title: 'Floor Area Next Gen'
      },
      {
        id: 'fd',
        title: 'Front Desk Umum'
      },
      {
        id: 'fd_ng',
        title: 'Front Desk Next Gen'
      }
    ]
    this.getGender()
    this.getServices()

    this.choices_list = [
      {
        id: 0,
        title: 'Belum Mengikuti'
      },
      {
        id: 1,
        title: 'Sedang Mengikuti'
      },
      {
        id: 2,
        title: 'Sudah Mengikuti'
      },
      {
        id: 3,
        title: 'Tidak lulus'
      }
    ]

    this.ready_list = [
      {
        id: 1,
        title: 'Bersedia'
      },
      {
        id: 0,
        title: 'Tidak Bersedia'
      }
    ]
  },
  methods: {
    getGender () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyGet('new_people/get_gender')
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.gender_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    getServices () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyGet('new_people/get_services')
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.service_list = response.data.data
          self.routine_service = self.service_list[0].id
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    checkClasses () {
      if (this.cob === 0 || this.cob === 3) {
        this.col = 0
        this.col_join = ''
        this.division = ''
      } else {
        if (this.col !== 2 && this.col !== 1) {
          this.division = ''
        }
      }
    },
    submitData () {
      // Preloader
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyPost('new_member/register', {
        name: this.name,
        birthday: this.birthday,
        gender: this.gender,
        phone: this.phone,
        email: this.email,
        job: this.job,
        date_group: this.date_group,
        date_group_since: this.date_group_since,
        date_group_leader_name: this.date_group_leader_name,
        date_group_leader_phone: this.date_group_leader_phone,
        routine_service: this.routine_service,
        partners_day: this.partners_day,
        partners_day_join: this.partners_day_join,
        cob: this.cob,
        cob_join: this.cob_join,
        col: this.col,
        col_join: this.col_join,
        division: this.division,
        why_join: this.why_join,
        ready: this.ready,
        self_image: this.self_image
      })
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        self.errors.clear()
        if (response.data.response_code === 1) {
          self.name = ''
          self.birthday = ''
          self.gender = ''
          self.phone = ''
          self.email = ''
          self.job = ''
          self.date_group = ''
          self.date_group_since = ''
          self.date_group_leader_name = ''
          self.date_group_leader_phone = ''
          self.routine_service = self.service_list[0].id
          self.partners_day = ''
          self.partners_day_join = ''
          self.cob = ''
          self.cob_join = ''
          self.col = ''
          self.col_join = ''
          self.division = ''
          self.why_join = ''
          self.ready = ''
          self.self_image = ''

          self.$geb.emit({id: 'alert_modal', title: 'Thank You!', content: 'Anda telah berhasil Register', button_text: 'OK'})
        } else {
          var result = response.data.message
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
          self.$geb.emit({id: 'alert_modal', title: 'Oops...', content: 'Ada data yang belum selesai di isi. Silahkan di cek kembali form yang anda isi', button_text: 'OK'})
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/NewMember.vue